import React from 'react';
import Config from "../config/Config";

import '../css/licensePage.css';

let  filePath =  Config.getFilePath();

class LicensePage extends React.Component {
  getLicenseInfo() {
    const { id } = this.props.match.params;
    const licenseData = {
      '1': { title: '人力资源服务许可证', img: 'HRSL' },
      '2': { title: '营业执照', img: 'BL' },
      '3': { title: '增值电信业务经营许可证', img: 'ICPL' }
    };
    return licenseData[id] || licenseData['1'];
  }

  goBack = () => {
    this.props.history.goBack();
  }

  render() {
    const license = this.getLicenseInfo();

    return (
      <div className="license-page">
        <img src={filePath +'/pinzhunzhun/'+  license.img + ".png"} alt={license.title} className="license-img" />
      </div>
    );
  }
}

export default LicensePage;
